export default __webpack_public_path__ + "1cbcbe8a9e03f131de04baf682d4b44f.ttf";